// Central haptic feedback using the Vibration API. Independent of audio mute.
// Note: supported on Android/Chrome; iOS Safari does NOT support navigator.vibrate.
const KEY = "nb_haptics";

// Only DAMAGE events buzz: getting hit / losing a heart ("hurt") and dying ("gameover").
const PATTERNS = {
  hurt: 35,
  gameover: [60, 80, 120],
};

let _enabled = null;

export function hapticsSupported() {
  return typeof navigator !== "undefined" && typeof navigator.vibrate === "function";
}

export function hapticsEnabled() {
  if (_enabled === null) {
    try { _enabled = localStorage.getItem(KEY) !== "0"; } catch { _enabled = true; }
  }
  return _enabled;
}

export function setHapticsEnabled(on) {
  _enabled = !!on;
  try { localStorage.setItem(KEY, on ? "1" : "0"); } catch (e) {}
  if (on && hapticsSupported()) {
    try { navigator.vibrate(15); } catch (e) {} // confirmation buzz
  }
}

// Fire a vibration only for damage events (matches AudioManager sfx names).
export function vibrate(name) {
  if (!hapticsSupported() || !hapticsEnabled()) return;
  const p = PATTERNS[name];
  if (p === undefined) return; // non-damage events do not buzz
  try { navigator.vibrate(p); } catch (e) {}
}
